import React, { Fragment, useContext, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Context } from '../Wizard/WizardWrapper';
import Span from '../Elements/Span';
import Label from '../Elements/Label';
import CustomIcon from '../Elements/CustomIcon';
import Select from '../Elements/Select';
import Markdown from '../Elements/Markdown';
import InputDate from '../Elements/InputDate';
import NationalitySelector from '../Elements/NationalitySelector';
import { ELECTION_TYPE } from '../../../../utils/constants';

const AustralianStatusNationality = ({
  item,
  classNameMarginTop,
  divClassName,
  fieldsValidated,
}) => {
  const { watch, resetField, errors } = useContext(Context);
  const electionTypeId = parseInt(watch('electionTypeId'));
  const australianStatusId = parseInt(watch('australianStatusId'));

  useEffect(() => {
    if (
      (electionTypeId === ELECTION_TYPE.ORDINARY ||
        electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION) &&
      item.name === 'australianStatusId' &&
      australianStatusId !== 3
    ) {
      resetField('arrivalDate');
      resetField('nationalityId');
    }

    if (electionTypeId === ELECTION_TYPE.CORRESPONDING_MEMBER) {
      resetField('australianStatusId');
      resetField('arrivalDate');
    }
  }, [item.name, australianStatusId, resetField, electionTypeId]);

  if (electionTypeId === ELECTION_TYPE.CORRESPONDING_MEMBER) {
    const fieldName = 'nationalityId';
    return (
      <div className={`${divClassName} ${classNameMarginTop}`}>
        <div className="form-group">
          <Label
            label="Nationality"
            name={fieldName}
            errors={errors}
            required
          />

          <CustomIcon
            fieldsValidated={fieldsValidated}
            fieldError={errors[fieldName]}
            required
          />

          <NationalitySelector name={fieldName} />
          <Span text={errors[fieldName] ? errors[fieldName].message : ''} />
        </div>

        <Markdown
          className="col-xl-12 col-lg-12 mt-3"
          text={item.description}
        />
      </div>
    );
  }

  return (
    <div className={`${divClassName} ${classNameMarginTop}`}>
      <div className="form-group">
        <Label
          label={item.label}
          name={item.name}
          errors={errors}
          required={item.required}
        />

        <CustomIcon
          fieldsValidated={fieldsValidated}
          fieldError={errors[item.name]}
          required={item.required}
        />

        <Select options="australian-statuses" name={item.name} />
        <Span text={errors[item.name] ? errors[item.name].message : ''} />

        {australianStatusId === 3 && (
          <>
            <Label
              label="Date arrived in Australia"
              name="arrivalDate"
              errors={errors}
              required
            />
            <CustomIcon
              fieldsValidated={fieldsValidated}
              fieldError={errors.arrivalDate}
              required
            />
            <InputDate name="arrivalDate" />
            <Span text={errors.arrivalDate ? errors.arrivalDate.message : ''} />
          </>
        )}
      </div>

      <Markdown className="col-xl-12 col-lg-12 mt-3" text={item.description} />
    </div>
  );
};

AustralianStatusNationality.propTypes = {
  item: PropTypes.object,
  classNameMarginTop: PropTypes.string,
  divClassName: PropTypes.string,
  fieldsValidated: PropTypes.bool,
};

export default AustralianStatusNationality;
